import { useEffect, useState } from 'react';
import AnimatedPage from '../../components/AnimatedPage';
import SmoothScrollingButton from '../../components/SmoothScrollingButton';
import { INNERPAGE_PRICING_PLAN } from '../../constants/Plans';
import Button from '../../components/common/Button';
import { useParams } from 'react-router-dom';
import PricingPageJourney from '../../components/modals/pricingPageJourney';
import InnerFeatureAccordion from '../../components/pricingPlans/InnerFeatureAccordion';
import { setCompany } from '../../reducers/companyReducer';
import { useDispatch, useSelector } from 'react-redux';

import freeSubscriptionBg from '../../../images/billing/innerPricingPlan.png'
import liteSubscriptionBg from '../../../images/billing/activeLite.png'
import proCard from '../../../images/billing/proCard.png'
import proTip from '../../../images/billing/proTip.png'

import { toggleModal } from '../../reducers/modalReducer';
import SubscriptionPaymentConfirm from '../../components/modals/SubscriptionPaymentConfirm/SubscriptionPaymentConfirm';
import { getRequest } from '../../config';

// Helper function to get modified plan based on subscription
const getModifiedPricingPlan = (subscription, basePlanData, setPricingData) => {
    const deepClone = JSON.parse(JSON.stringify(basePlanData));
    const planData = deepClone['Companies'];

    if (subscription && subscription === 'Free') {
        Object.values(planData.features).forEach(features => {
            Object.values(features).forEach(value => delete value['FREE']);
        });
        planData.plans = planData.plans.filter(p => p !== 'FREE');
        planData.headings = planData.headings.filter(p => p !== 'FREE');
        delete planData.pricing['FREE'];
        delete planData.buttonText['FREE'];
    }

    if (subscription && subscription === 'Lite') {
        Object.values(planData.features).forEach(features => {
            Object.values(features).forEach(value => delete value['FREE']);
        });
        planData.plans = planData.plans.filter(p => p !== 'FREE' && p !== 'LITE');
        planData.headings = planData.headings.filter(p => p !== 'FREE' && p !== 'LITE');
        delete planData.pricing['FREE'];
        delete planData.buttonText['FREE'];
    }

    if (subscription && subscription === 'Pro') {
        Object.values(planData.features).forEach(features => {
            Object.values(features).forEach(value => {
                delete value['FREE'];
                delete value['LITE'];
            });
        });
        planData.plans = planData.plans.filter(p => p !== 'FREE' && p !== 'LITE' && p !== 'PRO');
        planData.headings = planData.headings.filter(p => p !== 'FREE' && p !== 'LITE' && p !== 'PRO');
        delete planData.pricing['FREE'];
        delete planData.pricing['LITE'];
        delete planData.buttonText['FREE'];
        delete planData.buttonText['LITE'];
    }
    setPricingData({ "Companies": planData })
};

const InnerPricingPage = () => {
    const [tab] = useState("Companies");
    const dispatch = useDispatch();
    const { id } = useParams();
    const [modalData, setModalData] = useState(null);
    const [copied, setCopied] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState()
    const { selectedCompany } = useSelector((state) => state.company);
    const [pricingData, setPricingData] = useState()

    const fetchCompanyData = async (companyId) => {
        const spinner = document.getElementById('e1jygW4piZH1');
        spinner.classList.remove('op0');
        const response = await getRequest(`/company/get/${companyId}`)
        dispatch(setCompany(response['body']))
        spinner.classList.add('op0');
    }

    useEffect(() => {
        if (id) {
            fetchCompanyData(id)
        }
    }, [id]);

    const handleCopy = (code) => {
        navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleModalOpen = (data) => {
        setModalData(data);
    };

    useEffect(() => {
        if (selectedCompany && Object.keys(selectedCompany).length && selectedCompany['subscription']) {
            getModifiedPricingPlan(selectedCompany?.subscription, INNERPAGE_PRICING_PLAN, setPricingData);
        } else if (selectedCompany && Object.keys(selectedCompany).length && !selectedCompany['subscription']) {
            setPricingData(INNERPAGE_PRICING_PLAN);
        }
    }, [selectedCompany])

    const capitalizeWords = (text) =>
        text.split(' ').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' ')

    const handlePaymentPopup = (paymentPlan) => {
        if (disabled) return
        paymentPlan = capitalizeWords(paymentPlan)
        if (paymentPlan == 'Portfolio Pro') paymentPlan = "Pro";
        let activePlans = ['Free', 'Lite', 'Pro'];
        if (activePlans.includes(paymentPlan)) {
            setSelectedPlan(paymentPlan);
            dispatch(toggleModal({ open: 'subscriptionPaymentConfirm' }));
        }
    };

    // Disable all buttons and onClick events if no company is selected
    const disabled = !(selectedCompany && Object.keys(selectedCompany)?.length);

    return (
        <AnimatedPage>
            <div
                className="poppins-font-style bg1 pricing-plan-page"
                style={{
                    backgroundImage: `url(${selectedCompany && selectedCompany['subscription'] === "Lite" ? liteSubscriptionBg : freeSubscriptionBg})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#F5F7FF',
                    minHeight: '100vh',
                    overflowY: 'scroll'
                }}
            >
                <SmoothScrollingButton />

                <div
                    className='df jcc fdc aic pt2rem pb5rem pricing-tabs oh'
                >
                    <div className='pb1rem df jcc fdc tslp op1 tty0  w100 tal'>
                        <p className="dib fw500 fs2-125rem c15 tal w100 pl3rem" style={{ lineHeight: '62.2px' }}>
                            Our Plans
                        </p>
                        {/* <img className='pa' style={{ top: '0px', right: '3rem' }} src={require('../../../images/logo-icon.svg')} width={60} alt='logo-icon' /> */}
                    </div>

                    <div className='w100 tac'>
                        <div className={`dg gtcr5 pt4rem gg1rem w90 ma px2rem`}>
                            {
                                pricingData?.[tab]?.plans.length === 2 ? <><div></div><div></div><div></div></> : pricingData?.[tab]?.plans.length === 3 ? <><div></div><div></div></> : pricingData?.[tab]?.plans.length === 1 ? <><div></div><div></div><div></div><div></div></> : <><div></div></>
                            }

                            {pricingData?.[tab].plans.map((plan, index) => {
                                const isPaid = plan === "LITE" || plan === "PRO";
                                return (
                                    <div className='pr'>
                                        {
                                            ((selectedCompany && !selectedCompany['subscription'] && plan === "PRO") || (selectedCompany && selectedCompany['subscription'] && selectedCompany['subscription']?.toLowerCase() === "free" && plan === "PRO")) ? <img className='pa' style={{ top: '-58%', zIndex: 0, left: '12px' }} src={proCard} alt='proCard' /> : selectedCompany && selectedCompany['subscription'] && selectedCompany['subscription']?.toLowerCase() === "lite" && plan === "PRO" ? <><img className='pa' style={{ top: '-31%', zIndex: 0, left: '0px' }} src={proTip} alt='proTip' /></> : ''
                                        }
                                        <div key={index}
                                            className="df jcsb fdc aic bg1 br20px bo65 bw1px w100 mb1rem p1rem pr"
                                        >

                                            <div className="pr w100">
                                                {pricingData?.[tab].tag?.[plan] && (
                                                    <div className='df aic jcc'
                                                        style={{ width: '283px', height: '24px', position: 'absolute', top: '31px', left: '-299px' }}>
                                                        <img src={require('../../../images/pricing-page/tag.png')} alt='tag' />
                                                    </div>
                                                )}
                                                {plan === "PRO" ? (
                                                    <div className='df aic jcsb' style={{ height: '24px' }}>
                                                        <p className='c4 fs10px fw600 w100 tal'>MOST POPULAR</p>
                                                    </div>
                                                ) : <div className='df aic jcsb' style={{ height: '24px' }}></div>}

                                                {pricingData?.[tab]?.discount?.[plan] && (
                                                    <p className='c1 fs1rem fw600 tac pa'
                                                        style={{
                                                            backgroundImage: `url(${require('../../../images/pricing-page/discountVector.png')})`,
                                                            minHeight: '73px',
                                                            backgroundSize: 'contain',
                                                            backgroundRepeat: 'no-repeat',
                                                            backgroundPosition: 'right center',
                                                            right: '4px',
                                                            top: '-20px',
                                                            padding: '4px',
                                                        }}>
                                                        {pricingData?.[tab].discount[plan]} <br /> off
                                                    </p>
                                                )}
                                                <p className={`fs1-5rem c15 fw500 tal ${pricingData?.[tab]?.subTitle ? 'mb0-5rem' : 'mb2rem'}`}>
                                                    {plan}
                                                    <span className='c4 db fs12px fw400' style={{ height: '18px' }}>
                                                        {pricingData?.[tab]?.subTitle?.[plan] || ""}
                                                    </span>
                                                </p>

                                                <p className="c15 fw500 tal">
                                                    <span className="c3 fs2rem fw600">{pricingData?.[tab].pricing[plan]}</span>
                                                    <span>
                                                        {!['Custom', 'FREE'].includes(pricingData?.[tab].pricing[plan]) && `/month${isPaid ? "*" : ''}`}
                                                    </span>
                                                    <span className='db c15 op60 fs14px fw400'>
                                                        {isPaid ? <>* billed annually</> : ''}
                                                    </span>
                                                </p>
                                                <p className="fs1rem c15">{plan.description}</p>
                                            </div>
                                            <div className="df jcc fdc aic w100 mt1rem">
                                                {'Portfolio PRO ' === plan ? (
                                                    <p className='tal c71 fw400 cp fs12px pr'>
                                                        *= only available through {tab === "Investors" ? 'Investor' : "Advisor"} dashboard.
                                                        <span className='c4 cp' onClick={() => handleCopy(tab === "Investors" ? 'Code: INVESTOR20' : 'Code: ADVISOR20')}></span>
                                                        {copied && (
                                                            <span className='pa t0 r0 bg1' style={{ padding: '4px', borderRadius: '12px' }}>
                                                                (Copied!)
                                                            </span>
                                                        )}
                                                        . Billed annually
                                                    </p>
                                                ) : (
                                                    <>
                                                        <Button
                                                            style={{ maxHeight: "45px", paddingLeft: "8px", paddingRight: '8px', marginTop: isPaid ? '0px' : '25px' }}
                                                            customClassName='df aic jcc px0-5rem w100'
                                                            onClick={() => {
                                                                if (pricingData?.[tab].buttonText[plan] === "Book a call") {
                                                                    window.open("https://koalendar.com/e/meet-with-mark-bernstein");
                                                                } else {
                                                                    handlePaymentPopup(plan)
                                                                }
                                                            }}
                                                            btnType={pricingData?.[tab].pricing[plan] !== 'Custom' ? "warning" : "warningOutlined"}
                                                            text={pricingData?.[tab].buttonText[plan]}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className='w90 ma'>
                            {pricingData?.[tab] && Object.keys(pricingData?.[tab]).length && Object.entries(pricingData?.[tab].features).map(([section, items]) => {
                                return (
                                    <InnerFeatureAccordion
                                        subscription={selectedCompany['subscription'] || null}
                                        selectedCompany={selectedCompany}
                                        tab={tab}
                                        key={section}
                                        title={section}
                                        titleInfo={section}
                                        items={items}
                                        plans={pricingData?.[tab].headings}
                                        onModalOpen={handleModalOpen}
                                        handlePaymentPopup={handlePaymentPopup}
                                        disabled={disabled}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <SubscriptionPaymentConfirm
                plan={selectedPlan}
                defaultStep={selectedPlan === "Free" ? "freeMembership" : "subscriptionUpgrade"}
                company={selectedCompany}
                companyId={selectedCompany['_id']}
            />
            <PricingPageJourney modaldata={modalData} />
        </AnimatedPage>
    );
};

export default InnerPricingPage;
